'use strict';

newsOverviewService.$inject = ["newsService", "NewsOverview", "NewsSearchRequest", "common", "Enums", "$state", "$stateParams", "$q", "gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsOverviewService = newsOverviewService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function newsOverviewService(newsService, NewsOverview, NewsSearchRequest, common, Enums, $state, $stateParams, $q, gettextCatalog) {
    return {
        handleGetNews: handleGetNews
    };

    function handleGetNews(scope, context, defaultFilterAttr, pageSize) {
        var newsOverviewModel = NewsOverview.create(context, defaultFilterAttr, pageSize);
        return getNews(true, newsOverviewModel).then(function (model) {
            newsOverviewModel = model;
            listenForLocationChangeSuccess();
            return newsOverviewModel;
        });

        function listenForLocationChangeSuccess() {
            scope.$on('$locationChangeSuccess', function () {
                getNews(false, newsOverviewModel).then(function (model) {
                    newsOverviewModel = model;
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                }).catch(function () {
                    $state.go('error', {}, { location: false });
                });
            });
        }
    }

    function getNews(init, newsOverviewModel) {
        var params = getQueryStringParams(newsOverviewModel);
        var searchRequest = NewsSearchRequest.create(newsOverviewModel.context, params);
        return loadNews(init, newsOverviewModel, searchRequest, params.page);
    }

    function getQueryStringParams(newsOverviewModel) {
        var page = parseInt($stateParams.page);
        var pageSize = newsOverviewModel.paging.itemsPerPage;

        return {
            page: page,
            skip: newsOverviewModel.paging.getSkipValue(page, pageSize),
            take: pageSize,
            categoryId: $stateParams.categoryId === '0' ? null : parseInt($stateParams.categoryId),
            searchValue: $stateParams.searchValue,
            sellerId: newsOverviewModel.sellerId,
            brandId: newsOverviewModel.brandId,
            productId: newsOverviewModel.productId,
            tagId: newsOverviewModel.tagId
        };
    }

    function loadNews(init, model, searchRequest, page) {
        var promises = [];
        promises.push(newsService.getByCriteria(searchRequest));
        promises.push(init ? newsService.getCategories() : $q.when(null));

        model.errorOccurred = false;
        model.isLoadingInitial = init;

        return $q.all(promises).then(function (promiseResults) {
            var newsResult = promiseResults[0];
            var categoriesResult = promiseResults[1];
            model.paging.totalItems = newsResult.count;
            model.paging.page = page;
            model.items = newsResult.results;
            model.searchValue = $stateParams.searchValue || '';

            if (categoriesResult) {
                model.categories = categoriesResult;
                var allCategoriesText = gettextCatalog.getString('All categories');
                var allCategoriesItem = {
                    id: 0,
                    displayName: allCategoriesText
                };
                model.categories.splice(0, 0, allCategoriesItem);
                model.selectedCategory = allCategoriesItem;

                if ($stateParams.categoryId) {
                    var categoryId = parseInt($stateParams.categoryId);
                    var selectedCategory = _lodash2.default.find(model.categories, function (i) {
                        return i.id === categoryId;
                    });
                    if (selectedCategory) {
                        model.selectedCategory = selectedCategory;
                    }
                }
            }

            model.paging.update(page);

            if (init && model.items.length > 0) {
                model.isNewsAvailableForContext = true;
            }

            model.isNewsAvailableForCriteria = model.items.length > 0;

            model.isLoadingInitial = false;
            model.isLoading = false;
            return model;
        }).catch(function () {
            model.isLoadingInitial = false;
            model.isLoading = false;
            model.errorOccurred = true;
            return model;
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/newsOverviewService.js
// module id = 816
// module chunks = 0